import React from 'react'
import { connect } from 'react-redux'
import Modal from '../Modal'
import { addAutoresponseKeyword, deleteAutoresponseKeyword, editAutoresponseKeyword, } from '../redux/FeedbackRedux'
import AutoresponseKeyword from './AutoresponseKeyword'

class ChatSettingsAutoresponse extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            minutes: this.props.state.business.auto_response_minutes,
            message: this.props.state.business.auto_response_message ? this.props.state.business.auto_response_message : __('Thanks for submitting your Feedback. Someone will be responding to you shortly!'),
            checkbox: !!this.props.state.business.auto_response_active
        };
    }

    handleMinuteChange(event) {
        // this.props.dispatch(editPrecanned({uuid: uuid, text: event.target.value, type: 'text'}));
        this.setState({ minutes: event.target.value })
    }

    handleCheckBox(event) {
        console.log(this.state.checkbox);
        if (this.state.checkbox) {
            this.setState({ checkbox: false });
        } else {
            this.setState({ checkbox: true });
        }
    }

    handleAdd(event) {
        event.preventDefault();
        this.props.dispatch(addAutoresponseKeyword());
    }

    handleChangeKeyword(uuid, event) {
        this.props.dispatch(editAutoresponseKeyword({ uuid: uuid, text: event.target.value, type: 'keyword' }));
    }

    handleChangeResponse(uuid, event) {
        this.props.dispatch(editAutoresponseKeyword({ uuid: uuid, text: event.target.value, type: 'response' }));
    }

    handleDelete(uuid, event) {
        this.props.dispatch(deleteAutoresponseKeyword({ uuid: uuid, text: event.target.value, type: 'response' }));
    }

    render() {
        return (
            <div className="w-100">
                <form className="autoresponse-form" id="autoresponseform"
                      method="post"
                      action={"/business/" + this.props.state.business.business_id + "/chat-settings/autoresponse/post"}>
                    <div
                        className="w-100 border-bottom d-flex align-items-center bg-white p-2 shadow-sm filter-bar-wrapper mt-1">
                        <p className='w-100 mb-0 mx-3'>
                            {__('On this page you can enable auto-response which will send a message at a specified time interval to a Feedbacker who requested a response for their Feedback (for example: "Thank you for submitting your Feedback. Someone will be responding to you shortly!"). You can also automatically respond to Feedback that has certain keywords or phrases with a specific response.')}
                        </p>
                        <div className="d-flex mx-2 align-items-center">

                        </div>
                        <button className='btn btn-primary text-nowrap ml-auto mt-1' type='submit'>
                            <i className='fas fa-save mr-1'></i>
                            {__('Save Changes')}
                        </button>
                    </div>
                    <div className='col-md-12 mt-3'>
                        <div className="card">
                            <div className="card-body">
                                <h3>General</h3>
                                <hr/>
                                <p>
                                    <input className="d-inline-block ml-1" name="active"
                                           onChange={this.handleCheckBox.bind(this)} checked={this.state.checkbox}
                                           type="checkbox" id="autoresponse"/>
                                    <label htmlFor="autoresponse"
                                           className="d-inline-block ml-2 mb-0">{__('Enable')}</label>
                                </p>
                                <p>{__()}
                                    {__('You can customize the message the Feedbacker will receive, and you can specify the time you would like the system to wait before sending the auto-response message. If the Feedbacker receives a response from a staff member before the auto-response is triggered, the auto-response will not trigger')}.
                                </p>
                                <hr/>
                                <input type="hidden" name="_token" className="makecsrf"/>
                                <input type="hidden" defaultValue={this.props.state.business.business_id}
                                       name="business_id"/>
                                <div className='col pl-0'>
                                    <div className="col-sm-4 mb-3 pl-0">
                                        <h5>{__('Auto-Response Time (Minutes)')}:</h5>
                                        <div className="row mt-3">
                                            <div className="col-sm-12">
                                                <div className="input-group feedback-form-control border">
                                                    <input type="number" name="minutes"
                                                           disabled={(!this.state.checkbox)}
                                                           onChange={this.handleMinuteChange.bind(this)} min="0"
                                                           max="180"
                                                           value={this.state.minutes}
                                                           className="input form-control time"
                                                           placeholder=" "/>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-sm-8 pl-0">
                                        <h5 className="mb-2">{__('Auto-Response Message')}:</h5>
                                        <div className="input-group feedback-form-control border mt-3">
                                            <textarea
                                                className="input form-control placeholder-up"
                                                disabled={(!this.state.checkbox)}
                                                defaultValue={this.state.message}
                                                name="message"
                                                placeholder={__(' ')}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="col-sm-12 mt-3 pl-0">
                                        <p className="text-muted">{__('Auto-Response will trigger')}
                                            <span>{(this.state.minutes > 0 ? " " + this.state.minutes + " minute(s)" : " automatically")}</span> {__('after a Feedback (requesting a text/chat reply) has been submitted and has not yet received a reply')}.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex">
                                    <h3>{ __('Keyword-based') }</h3>
                                    <button type="button" className="btn btn-primary ml-5"
                                            onClick={this.handleAdd.bind(this)}>
                                        <i className="fas fa-plus-circle mr-1"></i>
                                        { __('Add keyword-based response') }
                                    </button>
                                </div>
                                <hr/>
                                <p>
                                    {__('Here you can select what case-insensitive keywords or phrases you would like to trigger an auto-response with, and choose how you would like the system to respond. If you have the General Auto-Response activated above, but a keyword/phrase is found, then the keyword/phrase response takes precedence.')}
                                </p>
                                <hr/>
                                {this.props.state.autoresponseKeywords && this.props.state.autoresponseKeywords.map((value, index) => {
                                    return (
                                        <AutoresponseKeyword key={value.uuid} idx={index} autoresponseKeyword={value}
                                                             changeKeyword={this.handleChangeKeyword.bind(this, value.uuid)}
                                                             changeResponse={this.handleChangeResponse.bind(this, value.uuid)}
                                                             delete={this.handleDelete.bind(this, value.uuid)}></AutoresponseKeyword>
                                    )
                                })}
                            </div>
                        </div>
                    </div>
                    <div className={'d-flex justify-content-center'}>
                        <button className='btn btn-primary text-nowrap' type='submit'>
                            <i className='fas fa-save mr-1'></i>
                            {__('Save Changes')}
                        </button>
                    </div>
                </form>
                <Modal modal={this.props.state.modal}/>
            </div>
        );
    }
}

function mapStateToProps (state) {
    return { state: state }
}

export default connect(mapStateToProps)(ChatSettingsAutoresponse);
